/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFileHeaderBlock } from './DatabaseFileHeaderBlock';
import {
    DatabaseFileHeaderBlockFromJSON,
    DatabaseFileHeaderBlockFromJSONTyped,
    DatabaseFileHeaderBlockToJSON,
} from './DatabaseFileHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseVideoHeaderBlock
 */
export interface DatabaseVideoHeaderBlock extends DatabaseFileHeaderBlock {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseVideoHeaderBlock
     */
    loop?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVideoHeaderBlock
     */
    objectFit?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseVideoHeaderBlock
     */
    objectPosition?: string;
}

/**
 * Check if a given object implements the DatabaseVideoHeaderBlock interface.
 */
export function instanceOfDatabaseVideoHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseVideoHeaderBlockFromJSON(json: any): DatabaseVideoHeaderBlock {
    return DatabaseVideoHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseVideoHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseVideoHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFileHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'loop': !exists(json, 'loop') ? undefined : json['loop'],
        'objectFit': !exists(json, 'objectFit') ? undefined : json['objectFit'],
        'objectPosition': !exists(json, 'objectPosition') ? undefined : json['objectPosition'],
    };
}

export function DatabaseVideoHeaderBlockToJSON(value?: DatabaseVideoHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFileHeaderBlockToJSON(value),
        'loop': value.loop,
        'objectFit': value.objectFit,
        'objectPosition': value.objectPosition,
    };
}

